import CookiesJS from 'cookies-js';

// Кнопка «Пересчитать расчёт по цели у всех» на списке пользователей.
// Пересчитывает всех, у кого выбрана цель, по текущим справочникам.
export function initRecalculateStats($, apiClient) {
    const $button = $('.action__recalculate-stats');
    if (!$button.length) return;
    const $result = $('.recalculate-stats__result');
    $button.on('click', async function () {
        if (!confirm('Пересчитать целевые значения у всех пользователей с целью? Ручные настройки специалистов сохранятся.')) return;
        $button.prop('disabled', true);
        $result.removeClass('text-danger').text('Считаю…');
        try {
            const r = await apiClient.recalculateAllUserStats(CookiesJS.get('auth_token'));
            $result.text(`Готово: обработано ${r.processed}, посчитано ${r.calculated}, `
                + `заблокировано ${r.blocked}, пропущено ${r.skipped}.`);
        } catch (e) {
            console.error(e);
            $result.addClass('text-danger').text('Не получилось. Подробности в консоли браузера.');
        } finally {
            $button.prop('disabled', false);
        }
    });
}
